"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCartCms = void 0;
var EmptyCartCms = /** @class */ (function () {
    function EmptyCartCms() {
        this.EmptyLinkLabel = 'Empty';
        this.EmptyCartModalHeading = 'Empty your cart';
    }
    return EmptyCartCms;
}());
exports.EmptyCartCms = EmptyCartCms;
//# sourceMappingURL=EmptyCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EmptyCart/EmptyCart.cms.js
// module id = 2343
// module chunks = 8